export default function TermsOfUse() {
	return <div>Terms of Use</div>;
}
